import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      border: '1px solid #e2e2e1',
      borderRadius: '4px',
      transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, '
        + 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        backgroundColor: '#fff',
        borderColor: '#a0a0a0',
      },
      '&.Mui-focused': {
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
      '&.Mui-error': {
        borderColor: '#dc3545',
        boxShadow: '0 0 0 0.2rem rgba(220,53,69,.25)',
      },
    },
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: 'rgba(0, 0, 0, 0.54)',
      },
      '&.Mui-error': {
        color: '#f44336 !important',
      },
    },
  },
};

function CustomTextField(props) {
  const { classes } = props;

  // Important placement of InputProps override as the last attribute since
  // some callers of CustomTextField may be specifying InputProps which would
  // otherwise override disableUnderline.
  return <TextField
    variant="filled"
    classes={classes}
    {...props}
    InputProps={{ ...props.InputProps, disableUnderline: true }}
  />;
}

export default withStyles(styles)(CustomTextField);
